module.exports = __webpack_public_path__ + "static/media/18.02adc320.mp4";